import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { PriceTag } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const PriceTagOrIncluded = (props)=>{
    const { getLabel , hasLabel  } = useIntl();
    const { originalPrice , discountedPrice , discountText , className , step  } = props;
    if (originalPrice === 0) {
        const labelKey = step ? `products.glasses.configurator.priceIsZero.${step}` : 'products.glasses.configurator.priceIsZero';
        return hasLabel(labelKey) ? /*#__PURE__*/ React.createElement("span", {
            className: className
        }, getLabel(labelKey)) : null;
    }
    if (discountedPrice === 0 && discountText && (discountText === null || discountText === void 0 ? void 0 : discountText.length) > 0) {
        return /*#__PURE__*/ React.createElement("span", {
            className: className
        }, discountText);
    }
    return /*#__PURE__*/ React.createElement(PriceTag, swcHelpers.extends({}, props));
};

export { PriceTagOrIncluded };
//# sourceMappingURL=PriceTagOrIncluded.js.map
